import React from "react";

export default function HomeMenuButton({icon, title, onClick}) {
    return(
        <div style={{maxHeight:"100%", height:"100%", display:"flex", flexDirection:"column",
            justifyContent:"center", alignItems:"center", cursor:"pointer"}}
            onClick={onClick}>
            <img src={icon} style={{height:"50%"}}/>
            <p style={{margin:"0px", color:"var(--font-color-white)", fontFamily: "AgencyR"}}>
                {title}
            </p>
        </div>
    );
}